/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation} from 'react-query'
import {toast} from 'react-toastify'
import {useListView} from '../../core/ListViewProvider'
import {ID, KTIcon} from '../../../../../../../../_metronic/helpers'
import {deleteData} from '../../core/_requests'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'

type Props = {
  id: ID
  title: string
}

const ActionsCell: FC<Props> = ({id, title}) => {
  const {openEditTab} = useListView()
  const {refetch} = useQueryResponse()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const deleteItem = useMutation(() => deleteData(id), {
    onSuccess: () => {
      refetch()
      toast.success('Data deleted successfully')
    },
    onError: () => {
      toast.error('Failed to delete data')
    }
  })

  const handleDelete = async () => {
    if (window.confirm(`Apakah Anda yakin ingin menghapus tiket "${title}"?`)) {
      await deleteItem.mutateAsync()
    }
  }

  return (
    <div className='d-flex justify-content-end flex-shrink-0'>
      {/* Tombol Edit */}
      <button
        title='Edit Tiket'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        onClick={() => {
          if (openEditTab) openEditTab({id, title})
        }}
      >
        <KTIcon iconName='pencil' className='fs-3' />
      </button>

      {/* Tombol Delete */}
      <button
        title='Hapus Tiket'
        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
        onClick={handleDelete}
        disabled={deleteItem.isLoading}
      >
        {deleteItem.isLoading ? (
          <span className='spinner-border spinner-border-sm align-middle'></span>
        ) : (
          <KTIcon iconName='trash' className='fs-3' />
        )}
      </button>
    </div>
  )
}

export {ActionsCell}